import UploadC from './UploadC'
import './index.less'

export default UploadC
